import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            authUrl:null,
            clientId: null, 
            accountId: null, 
            redirectUrl: null, 
            accountSecret: null, 
            connectedAppStoreAccounts: [], 
            authBaseUrl: "https://appleid.apple.com/auth/authorize?client_id=", 
            packages:[]
        }
    },
    getters,
    actions,
    mutations
}
